import script from "./cForm.vue?vue&type=script&lang=js"
export * from "./cForm.vue?vue&type=script&lang=js"

import "./cForm.vue?vue&type=style&index=0&id=aa154154&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa154154"],['__file',"src/components/cmp/cForm/cForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aa154154"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aa154154', __exports__)) {
    api.reload('aa154154', __exports__)
  }
  
}


export default __exports__